import { windowWidth } from "src/styles/global";
import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  > :first-child {
    max-width: 300px;
    width: 300px;

    @media (max-width: ${windowWidth.mobile.large}) {
      max-width: unset;
      width: unset;
    }
  }
`;

const UsersBoard = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  align-content: start;
  overflow: hidden;
  overflow-y: scroll;
  gap: 15px;
  padding: 5px 5px 102px;

  @media (max-width: ${windowWidth.mobile.large}) {
    grid-template-columns: minmax(300px, auto);
  }
`;

const NoRecordsFound = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  width: 100%;
  font-size: 14px;
  color: #888888;

  grid-column: 1 / -1;
`;

export { Container, UsersBoard, NoRecordsFound };